<app-small-tuile
  type="icon"
  icon="fa-kit fa-picto-pacwp"
  [title]="
    this.titles[actionStack!.getValue('wpPModeFonctionnementTemperature')]
      | translate
  "
  [content]="buttons[this.actionStack!.getValue('wpCModeFonctionnement')].icon!"
  [color]="buttons[this.actionStack!.getValue('wpCModeFonctionnement')].color!"
  [status]="
    buttonMode[this.actionStack!.getValue('wpSEtatFonctionnementPAC')].title!
      | translate
  "
  [mode]="
    this.actionStack!.getValue('wpPTemperatureConsigne') === 0
      ? ''
      : getTemperature(
          this.actionStack!.getValue('wpPTemperatureConsigne') / 10,
          0
        )
  "
  [statusMode]="
    buttonMode[this.actionStack!.getValue('wpSEtatFonctionnementPAC')].status!
  "
  (onPress)="this.openProductModal()"
>
</app-small-tuile>
